import React, { FunctionComponent, useState } from 'react';
import { makeStyles, createStyles, Box, Grid } from '@material-ui/core';
import Loader from '../../../../components/Loader';
import AddCommentField from '../../../../components/AddCommentField';
import { Appointment, CommentList, Comment } from '../../../../store/modules/application/types';
import EmptyRecord from '../../../../components/TableView/TableEmptyState';
import CommentInfiniteScroll from '../../../../components/CommentInfiniteScroll';

type AppointmentCommentProps = {
    addAppointmentComment: Function;
    loading?: Boolean;
    appointmentDetails: Appointment;
    appointmentCommentList: CommentList;
    getAppointmentCommentsList: Function;
    skip: number;
    setSkip: Function;
    hasMore: boolean;
};

const AppointmentComment: FunctionComponent<AppointmentCommentProps> = (props) => {
    const {
        addAppointmentComment,
        loading,
        appointmentDetails,
        appointmentCommentList,
        skip,
        setSkip,
        hasMore,
    } = props;

    const useStyles = makeStyles(() =>
        createStyles({
            addAppointmentCommentDialog: {
                display: 'flex',
                flexGrow: 1,
                background: '#ffffff',
                width: '75%',
                padding: '25px',
                borderRadius: '5px',
                boxShadow:
                    '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                marginLeft: 'auto',
                marginRight: 'auto',
                height: '100%',
                overflow: 'hidden',
            },
            comments: {
                width: '100%',
                marginTop: '40px',
            },
        }),
    );
    //@ts-ignore
    const classes = useStyles();
    const [isAddAppointmentCommentOpen, setAddAppointmentCommentOpen] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');
    const handleChangeComment = (event: React.ChangeEvent<{ name?: string; value: string }>) => {
        setComment(event.target.value);
    };

    const handleAddAppointmentCommentChange = () => {
        addAppointmentComment(comment, appointmentDetails?.id);
        setComment('');
        setAddAppointmentCommentOpen(false);
    };

    const sortedList = (a: Comment, b: Comment) => {
        const date1 = new Date(b.timestamp).valueOf();
        const date2 = new Date(a.timestamp).valueOf();
        return date1 - date2;
    };
    const loadMore = () => {
        if (hasMore) {
            setSkip(skip + 1);
        }
    };

    const sortedCommentList = appointmentCommentList?.sort((a: Comment, b: Comment) => {
        return sortedList(a, b);
    });

    if (loading) {
        return <Loader />;
    }
    return (
        <Box className={classes.addAppointmentCommentDialog}>
            <Grid container className="verticalFillContainer">
                <AddCommentField
                    isAddCommentFieldOpen={isAddAppointmentCommentOpen}
                    setAddCommentFieldOpen={setAddAppointmentCommentOpen}
                    setComment={setComment}
                    handleAddCommentChange={handleAddAppointmentCommentChange}
                    handleChangeComment={handleChangeComment}
                    disabled={!!comment ? false : true}
                />
                <Box className={`${classes.comments} verticalFillContent`}>
                    {sortedCommentList.length > 0 ? (
                        <CommentInfiniteScroll
                            loadMore={loadMore}
                            hasMore={hasMore}
                            data={sortedCommentList}
                            scrollableTarget="appointmentComment"
                        />
                    ) : (
                        <Box>
                            <EmptyRecord title="No active records for this license. " message=" " />
                        </Box>
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default AppointmentComment;
